import type { NavLinkItem, ShippingDetail, Address } from './types';
import siteConfig from './siteConfig.json';

export const COMPANY_NAME = "Custom Label Shop";
export const CONTACT_EMAIL = "info@customlabelshop.com"; // Placeholder
export const PHONE_NUMBER = "1-866-828-2776"; // Placeholder
export const SITE_URL = siteConfig.siteUrl;

export const NAV_LINKS: NavLinkItem[] = [
  { href: "#home", label: "Home" },
  { href: "#benefits", label: "Benefits" },
  { href: "#our-labels", label: "Our Labels" },
  { href: "#pricing", label: "Pricing" },
  { href: "#faq", label: "FAQ" },
  { href: "#contact", label: "Contact" },
];

export const CORE_BENEFITS_LIST: string[] = [
  "Improve customer loyalty and sell more beer",
  "Clearly identify every adult beverage as 'purchased on premises'",
  "Prove to licensing authorities your commitment to full compliance",
  "Discourage patrons from bringing their own beverages",
  "Make enforcement easier for on-course staff",
];

export const LABEL_FEATURES_LIST: string[] = [
  "Specifically designed for application to cans and bottles of adult beverages such as beer, ciders, and coolers.",
  "Will withstand the rigors of life in a beer cart or golf bag with ease.",
  "Printed on label stock designed specifically to work on all types of surfaces and in cold storage conditions.",
  "Available in a wide selection of highly visible colors.",
  "Labels are laminated for durability. They will not fall apart when wet and make a huge mess of your beverage cart coolers, or your patrons’ golf bags.",
  "Upon removal, the print and laminate layers separate, making it impossible to reuse labels on an outside beverage (Tamper-Evident).",
];

export const SHIPPING_CANADA: ShippingDetail = {
  provider: "FedEx Ground",
  transitTime: "2-4 business days",
  singleRollCost: 20.00,
  additionalRollCost: 0.00,
  freeShippingThreshold: 10,
};

export const SHIPPING_USA: ShippingDetail = {
  provider: "USPS Priority Mail",
  transitTime: "3-5 business days",
  singleRollCost: 20.00,
  additionalRollCost: 0.00,
  freeShippingThreshold: 10,
};

export const RETURN_POLICY_ADDRESS: Address = {
  name: "Custom Label Shop",
  street: "47556 Swallow Cr.",
  city: "Chilliwack, BC, V2P 7R4",
  country: "Canada",
};
